


export class PublicationProfileCardView {

    constructor() {

        this.boxes = document.querySelectorAll('.post_author');
		if (!this.boxes) { return false;}
    }

    render(state) { 

        if (!state) { return false;}
		
		if (!this.boxes) { return false;}

		const data = state.data;
		if (!data) { return false;}
		
		this.boxes.forEach((box) => {
			
			const a = box.querySelector('.title a');
			const avatar = box.querySelector('a.avatar');
			
			if (data.username) {
				a.textContent = data.username;
				avatar.querySelector('img').attr = data.username;
			}
			
			if (data.url) {
				a.href = data.viewUrl;
				avatar.href = data.viewUrl;
			}
			
			if (data.avatarUrl) {
				avatar.querySelector('img').src = data.avatarUrl;
			}
			
			if (data.role) {
				const roleEl = box.querySelector('.title > span');
				if (roleEl) { roleEl.textContent = data.role;}
			}
			
			const followButton = box.querySelector('.button.follow');
			if (followButton && data.followButton) {
				followButton.querySelector(':scope > span').textContent = data.followButton.title;
				followButton.classList.toggle('toggled', data.followButton.isActive);
			}
			
			const counterBox = box.querySelector('.counters');

			if (data.summary) {
				
				
				
				if (data.summary.publications) {
					const publications = data.summary.publications;
					
					const counter = counterBox.querySelector('.ci.posts > .b');
					counter.href = publications.url;
					counter.setAttribute('data-tooltip', publications.title);
					counter.querySelector(':scope > span').textContent = publications.value;
				}
            }

            if (data.subscribers) {
                const subscribers = data.subscribers;
                
                const counter = counterBox.querySelector('.ci.followers > .b');
                counter.setAttribute('data-tooltip', subscribers.title);
                counter.querySelector(':scope > span').textContent = subscribers.value;
            }
			
			box.classList.remove('dummy');
		});
    }
}